import { CuiBottomSheet } from 'front-lib'
import './OrderSummaryMealsModal.scss'
import { OrderSummaryMeals } from '../OrderSummaryMeals/OrderSummaryMeals'
import tracking from 'src/shared/tracking'
import GiftsSection from 'src/componentsV2/GiftsSection/GiftsSection'

export const OrderSummaryMealsModal = ({
  meals,
  addons,
  onEditItems,
  isOpen,
  onClose
}) => {
  const onCloseClick = () => {
    tracking.track('CTA Button Clicked', {
      cta_text: 'Close View Selection'
    })
    onClose()
  }
  return (
    <CuiBottomSheet className="order-summary-meals-modal-v2" isOpen={isOpen}>
      <CuiBottomSheet.Header
        onRequestClose={onCloseClick}></CuiBottomSheet.Header>
      <CuiBottomSheet.Body className="modal-sheet-body">
        <OrderSummaryMeals
          meals={meals}
          addons={addons}
          onEditItems={onEditItems}
        />
        <GiftsSection />
      </CuiBottomSheet.Body>
    </CuiBottomSheet>
  )
}
